import locationsTotalWidgetTemplate from './locationsTotalWidget.html';
import './locationsTotalWidget.scss';

export default angular
  .module('main.dashboardPanel.locationsTotalWidget', [])

  .directive('locationsTotalWidget', () => {
    return {
      restrict: 'E',
      template: locationsTotalWidgetTemplate,
      scope: {},
      controller: ($scope,
                   utils,
                   DashboardDataProvider) => {
        $scope.noData = false;
        init();

        function init() {
          $scope.loading = true;

          DashboardDataProvider.getLocationsTotalLastWeek()
            .then((reportInfo) => {
              $scope.loading = false;
              if (!reportInfo || !reportInfo.dictionary || reportInfo.dictionary.length <= 0 || !reportInfo.executions || reportInfo.executions.length <= 0) {
                $scope.noData = true;
                return;
              }

              let executions = reportInfo.executions
                .slice()
                .sort((a, b) => a.executionDateMs - b.executionDateMs) // latest last
                .map(execution => ({
                  ...execution,
                  total: execution.data?.find((d) => d.id === 1)?.value
                }));

              let lastExecution = executions[executions.length - 1];
              if (!lastExecution.data) {
                $scope.noData = true;
                return;
              }

              $scope.trend = DashboardDataProvider.calculateTrend(executions, 'total');
              $scope.trendDate = new Date(executions[0].executionDateMs);
              $scope.locationsTotal = lastExecution.total;
            }, (err) => {
              utils.handleApiError(err);
              $scope.noData = true;
              $scope.loading = false;
            });
        }
      }
    };
  })
  .name;
